var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrollbar-xs",attrs:{"id":"app"}},[_c('backTop'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }